// RU-SUITEOPS SO-2: the RU-STRATLINK paper pause / resume request (PositionsTable keeps its own identical inline call).
// expect_mode "paper": the server refuses (409) when the stored deployment is not paper any more (SL-11), so this
// can never touch a live strategy.
export const pausePaperStrategy = (api, sid, enabled) =>
  api.post(`/strategies/${sid}/deploy`, { mode: "paper", enabled, expect_mode: "paper" });

// SO-2 / SO-6: only paper rows the server marked pausable get the control; live rows never.
export const isPausablePaper = (s) => s?.deployment?.mode === "paper" && s?.pausable === true;
export const isLive = (s) => s?.deployment?.mode === "live";
